import { Alert } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Chess, useChess } from 'api/chess';

import { Helmet } from 'react-helmet';
import { Box, CustomBox, GridChild, GridContainer } from 'common';
import { useEffect, useState } from 'react';
import { ChessCard } from 'widgets/cards';

import { useLanguage } from '../../context/LanguageContext';
import { chessClubPageLabels } from '../../locales/translations'

export const ChessPage = () => {
    const [chessList, setChessList] = useState<Chess[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const { onGetAllChess } = useChess();

    const { language } = useLanguage();
    const title = chessClubPageLabels.title[language];
    const pageTitle = chessClubPageLabels.pageTitle[language];
    const metaDescription = chessClubPageLabels.metaDescription[language];

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllChess();
                if (result.success) {
                    const sortedChess = result.data
                        .filter((a: Chess) => a.show)
                        .sort((a: Chess, b: Chess) => 
                            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                        );
                    setChessList(sortedChess);
                } else {
                    setError('Произошла ошибка при загрузке новостей');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    }, [onGetAllChess]);

    return (
        <CustomBox title={title}>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
            </Helmet>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : (
                <Box>
                    <GridContainer>
                        {chessList.map((chessItem) => (
                            <GridChild md={3} key={chessItem.id}>
                                <ChessCard chessItem={chessItem} />
                            </GridChild>
                        ))}
                    </GridContainer>
                </Box>
            )}
        </CustomBox>
    );
};
